import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=4fa726b0&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=js&"
export * from "./baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=4fa726b0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa726b0",
  null
  
)

export default component.exports